// test1598
(1598 && 0);
